import React from 'react';
import EmployeeContactInfo from './EmployeeProfileSections/employeeContactView';

export const ContactInfo = ({record}) =>
  <div>
    <EmployeeContactInfo data={record} />
  </div>;

export default ContactInfo;
